import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../../core/services/authentication.service';
import { NotifierService } from 'angular-notifier';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    // evita que várias requisições com 401 disparem vários redirecionamentos
    private redirecionandoLogin = false;

    constructor(private authenticationService: AuthenticationService,
                private router: Router,
                private notifierService: NotifierService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                if(!err.url || err.url.indexOf("login")==-1) {
                    // sessão expirada: faz logout e volta para o login uma única vez
                    this.authenticationService.logout();
                    if (!this.redirecionandoLogin && this.router.url.indexOf('/login') !== 0) {
                        this.redirecionandoLogin = true;
                        this.notifierService.notify( 'warning', 'Sua sessão expirou. Faça login novamente.');
                        this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } })
                            .then(() => this.redirecionandoLogin = false, () => this.redirecionandoLogin = false);
                    }
                } else {
                    this.notifierService.notify( 'error', err.error.error);
                }

            }

            const error = (err.error) ? err.error : err.message || err.statusText;
            return throwError(error);

        }))
    }
}
